// extracted by css-extract-rspack-plugin
export default {"contributionBlockedBanner":"EmuContributionBlockedBanner-module__contributionBlockedBanner__IMNIXbE"};